import axios from 'axios';
import { isDev } from '@/config';
// const apiUrl = isDev ? '//jprx.sparta.html5.qq.com' : '//jsonproxy.3g.qq.com';

const apiUrl = isDev ? '//jsyncmqq.3g.qq.com' : '//jsonproxy.3g.qq.com';// 临时
const JsonProxy = {
  _request(cmdId, params) {
    const req = {
      req: params,
    };
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: `${apiUrl}/forward?cmdid=${cmdId}`,
        data: JSON.stringify(req),
        contentType: 'text/plain',
        dataType: 'json'
      }).then(res => {
        if (res.data.ret == 0) {
          resolve(res.data.data.resp);
        } else {
          reject(res);
        }
      })
        .catch(e => {
          console.log('e:', e);
          reject(e);
        });
    });
  },

  getMidasProductTokenReq(params, callback) {
    return this._request(2159, params, callback);
  },

  getBuyProductUrlReq(params, callback) {
    return this._request(1818, params, callback);
  },
  getVipProductsMsgReq(params, callback) {
    return this._request(1817, params, callback);
  },
  useCouponCode(params, cb) {
    return this._request(1201, params, cb);
  },
};

export default JsonProxy;
